import { AppointmentRegistry } from "./AppointmentRegistry";

/**
 * Shared singleton instance of AppointmentRegistry for the entire app.
 * All appointment data (calendar, modal, etc.) is merged into and read from this instance.
 */
let appointmentRegistryInstance: AppointmentRegistry | null = null;

export function getAppointmentRegistry(): AppointmentRegistry {
  if (!appointmentRegistryInstance) {
    appointmentRegistryInstance = new AppointmentRegistry();
  }
  return appointmentRegistryInstance;
}
